// SNS 로그인(카카오/네이버) 설정 섹션 URL (2026-08-07 KST 추가)
const snsLoginSettingsSection = "/sns-login-settings";

export const snsLoginSettingsPath = snsLoginSettingsSection;
